import { SCHOOL_URL } from "../../crud/helpers/routes";
import { getParams, handleResponse } from "../../crud/helpers/validate";
import notice from "../../utils/notice";

export const TITLE_CHARACTER_LIMIT = 40;
export const BODY_CHARACTER_LIMIT = 144;

export const defaultNotify = {
  contentId: "",
  contentTitle: "",
  title: "",
  body: "",
  all_teams: false,
  schools_id: [],
  students_id: [],
  teams_id: [],
};

export const searchFunction = (slug = "") => {
  let searchStudents = (query = "") =>
    fetch(
      `${SCHOOL_URL}/${slug}/students/suggestions?q=${query}`,
      getParams("GET")
    )
      .then(handleResponse)
      .then((res) =>
        res.map(({ user, ...other }) => ({
          ...other,
          name: `${user?.first_name} ${user.last_name}`,
        }))
      )
      .catch((e) => {
        notice("Error on loading staff members");
        console.error(e.errors);
        throw e;
      });
  let searchTeams = (query = "") =>
    fetch(
      `${SCHOOL_URL}/${slug}/teams?page=${1}&search_query=${query}`,
      getParams("GET")
    )
      .then(handleResponse)
      .catch((e) => {
        notice("Error on loading teams");
        console.error(e.errors);
        throw e;
      });
  return {
    searchStudents,
    searchTeams,
  };
};
